/**
 * LifeRamp
 *
 * @author      Afaan Bilal
 * @copyright   LifeRamp Inc.
 *
 * Built by Eonyx Infotech LLP.
 * @link https://eonyx.io
 *
 */

import React from "react";
import { View, FlatList, StyleSheet } from "react-native";
import { useDispatch, useSelector } from "react-redux";
import { AntDesign } from "@expo/vector-icons";
import { LinearGradient } from "expo-linear-gradient";
import BouncyCheckbox from "react-native-bouncy-checkbox";

import { Colors, Gradients } from "../../../themes/colors";
import { FontSize, Size, SpacingH } from "../../../themes/sizes";
import fonts from "../../../themes/fonts";
import { GlobalStyles } from "../../../themes/styles";
import CircleButton from "../../../components/buttons/CircleButton";
import GoalProgressCard from "../../../components/cards/GoalProgressCard";
import PlaceHolder from "../../../components/utils/PlaceHolder";

import { Goals } from "../../../api";
import { setGoal } from "../../../state/slices/goalSlice";

export default ({ navigation, route }) => {
    const dispatch = useDispatch();

    const goal = useSelector(state => state.goal);
    const clientGoals = useSelector(state => state.goal.clientGoals);

    const client = route.params?.client || false;

    React.useEffect(() => {
        dispatch(Goals.refreshClientGoals({ client }));
    }, []);

    const loadMore = () => {
        if (goal.loading) return;
        goal.clientPage <= goal.clientMaxPage && dispatch(Goals.getClientGoals({ page: goal.clientPage }));
    };

    const viewGoal = (goal) => {
        dispatch(setGoal({ goal }));
        navigation.navigate("ViewClientGoal", { client });
    };

    const [filterType, setFilterType] = React.useState(["professional", "educational", "personal"]);

    const toggleFilter = (type) => {
        let categories = filterType.filter(t => t != type);

        if (!filterType.includes(type)) {
            categories = [...categories, type];
        }
        setFilterType(categories);
    };

    const filteredClientGoals = clientGoals.filter(g => filterType.includes(g.type));

    return (
        <View style={{ flex: 1, backgroundColor: Colors.WHITE }}>
            <FlatList
                style={GlobalStyles.containerPaddingH}
                data={filteredClientGoals}
                onRefresh={() => dispatch(Goals.refreshClientGoals())}
                refreshing={goal.clientRefreshing || goal.loading}
                onEndReached={loadMore}
                renderItem={({ item }) => <GoalProgressCard {...item} onPress={() => { viewGoal(item) }} />}
                ListEmptyComponent={<PlaceHolder status={(goal.clientRefreshing || goal.loading)} type={"regularCard"} />}
                keyExtractor={item => item.uuid}
                ListHeaderComponent={
                    <View style={{ flexDirection: "row", justifyContent: "center", marginVertical: SpacingH.s2 }}>
                        <View style={styles.checkboxContainer}>
                            <BouncyCheckbox
                                size={22}
                                fillColor={Colors.TEXT_BLACK}
                                unfillColor="#FFFFFF"
                                text="Professional"
                                textStyle={styles.checkboxItem}
                                iconStyle={{ borderColor: Colors.TEXT_BLACK, borderRadius: 3, marginRight: "-9%" }}
                                disableBuiltInState
                                isChecked={filterType.includes("professional")}
                                onPress={() => { toggleFilter("professional") }}
                            />
                        </View>
                        <View style={styles.checkboxContainer}>
                            <BouncyCheckbox
                                size={22}
                                fillColor={Colors.TEXT_BLACK}
                                unfillColor="#FFFFFF"
                                text="Educational"
                                textStyle={styles.checkboxItem}
                                iconStyle={{ borderColor: Colors.TEXT_BLACK, borderRadius: 3, marginRight: "-9%" }}
                                disableBuiltInState
                                isChecked={filterType.includes("educational")}
                                onPress={() => { toggleFilter("educational") }}
                            />
                        </View>
                        <View style={styles.checkboxContainer}>
                            <BouncyCheckbox
                                size={22}
                                fillColor={Colors.TEXT_BLACK}
                                unfillColor="#FFFFFF"
                                text="Personal"
                                textStyle={styles.checkboxItem}
                                iconStyle={{ borderColor: Colors.TEXT_BLACK, borderRadius: 3, marginRight: "-9%" }}
                                disableBuiltInState
                                isChecked={filterType.includes("personal")}
                                onPress={() => { toggleFilter("personal") }}
                            />
                        </View>
                    </View>
                }
                ListFooterComponent={<View style={{ height: SpacingH.s5 }} />}
            />
        </View>
    );
};

const styles = StyleSheet.create({
    checkboxContainer: {
        flexDirection: "row",
        alignItems: "center",
        width: Size.w30,
    },
    checkboxItem: {
        fontSize: FontSize.SMALLER,
        fontFamily: fonts.MainMedium,
        color: Colors.TEXT_BLACK,
        textDecorationLine: "none",
    },
});
